/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const FormFieldInput = styled.input`
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid ${props => props.theme.WHITE};
  padding: 10px 5px;
  font-size: 18px;
  color: ${props => props.theme.SECONDARY};

  ::placeholder {
    font-size: 18px;
    color: ${props => props.theme.SECONDARY};
  }
`;

function FormField({
  label, labelId, name, type, value, placeholder, isRequired, isDisabled, onChange, inputId,
}) {
  return (
    <FormFieldContainer>
      {label && (
        <label htmlFor={name} id={labelId}>
          {label}
          {isRequired && <span>*</span>}
        </label>
      )}

      <FormFieldInput
        id={inputId}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        required={isRequired}
        disabled={isDisabled}
        onChange={onChange}
      />
    </FormFieldContainer>
  );
}

FormField.propTypes = {
  label: PropTypes.string,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
};

FormField.defaultProps = {
  type: 'text',
  placeholder: '',
  isRequired: false,
  isDisabled: false,
};

export default FormField;
